import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: "flex",
  },
  templateContainer: {
    marginTop: 16,
  },
  templateHeader: {
    padding: 0,
    margin: "0 0 4px 0",
  },
  templateError: {
    fontSize: 12,
    color: theme.palette.error.main,
  },
  transformationContainer: {
    marginTop: 16,
  },
  transformationHeader: {
    padding: 0,
    margin: "0 0 4px 0",
  },
  transformationError: {
    fontSize: 12,
    color: theme.palette.error.main,
  },
}));
